import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(identifier.trim(), pwd);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate(res.user.role === "admin" ? "/admin" : from, { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2 bg-white" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src="https://images.pexels.com/photos/33562235/pexels-photo-33562235.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/40 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <h2 className="font-display text-7xl tracking-tighter leading-[0.85]">WELCOME<br />BACK,<br /><span className="text-[#FF3B30]">RUNNER.</span></h2>
          <p className="text-white/80 mt-6 max-w-md">Pick up where you left off — your wishlist and drop alerts are waiting.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-md space-y-6">
          <div>
            <div className="font-mono text-xs text-[#FF3B30] tracking-widest">ELMNTS / SIGN IN</div>
            <h1 className="font-display text-5xl tracking-tighter mt-2 text-black">LOGIN</h1>
          </div>
          <label className="block">
            <span className="font-display tracking-widest text-[10px] text-black/50">EMAIL OR MOBILE NUMBER</span>
            <input
              type="text"
              required
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="you@example.com or 9876543210"
              className="w-full bg-transparent border-b border-black/30 focus:border-black outline-none py-3 text-black placeholder:text-black/30"
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <span className="font-display tracking-widest text-[10px] text-black/50">PASSWORD</span>
            <input
              type="password"
              required
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              className="w-full bg-transparent border-b border-black/30 focus:border-black outline-none py-3 text-black"
              data-testid="login-password"
            />
          </label>
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-black text-white py-4 font-display tracking-widest text-sm hover:bg-[#FF3B30] transition-colors disabled:opacity-60"
            data-testid="login-submit"
          >
            {busy ? "SIGNING IN..." : "SIGN IN"}
          </button>
          <p className="text-sm text-black/60 text-center">
            New here? <Link to="/register" className="underline font-semibold text-black hover:text-[#FF3B30]" data-testid="link-register">CREATE ACCOUNT</Link>
          </p>
          <p className="text-xs text-center">
            <Link to="/forgot-password" className="text-black/60 hover:text-[#FF3B30] underline font-mono tracking-widest" data-testid="link-forgot-password">FORGOT PASSWORD?</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
